import { pick } from 'lodash';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

const ActionTypes = {
  SET_INITIAL_VALUES: 'app/ReferralPage/SET_INITIAL_VALUES',
  GENERATE_TOKEN_REQUEST: 'app/ReferralPage/GENERATE_TOKEN_REQUEST',
  GENERATE_TOKEN_SUCCESS: 'app/ReferralPage/GENERATE_TOKEN_SUCCESS',
  GENERATE_TOKEN_ERROR: 'app/ReferralPage/GENERATE_TOKEN_ERROR',
};

// ================ Initial State ================ //

const initialState = {
  generateTokenInProgress: false,
  generateTokenError: null,
  sdkToken: null,
};

// ================ Reducers ================ //

const ReferralPageReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case ActionTypes.SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case ActionTypes.GENERATE_TOKEN_REQUEST:
      return { ...state, generateTokenError: null, generateTokenInProgress: true };
    case ActionTypes.GENERATE_TOKEN_SUCCESS:
      return {
        ...state,
        generateTokenError: null,
        generateTokenInProgress: false,
        sdkToken: payload,
      };
    case ActionTypes.GENERATE_TOKEN_ERROR:
      return { ...state, generateTokenError: payload, generateTokenInProgress: false };

    default:
      return state;
  }
};

// ================ Selectors ================ //

// ================ Actions Creators ================ //
export const setInitialValues = initialValues => ({
  type: ActionTypes.SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

// ================ Thunks ================ //

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  const currentUser = await dispatch(fetchCurrentUser({ enforce: true }));
  const currentUserId = currentUser?.id;

  return currentUserId;
};

export default ReferralPageReducer;
